<template>
	<div>
		<div class="row">
			<div class="col-12">
				<g-table-sync
					:app="app"
					:view="view"
					pagination="loadmore"
					:default-limit="12"
					:default-filters="filters"
					:columns="columns"
				>
					<template
						slot="empresa"
						slot-scope="item"
					>
						<router-link
							v-if="item.Empresa"
							tag="a"
							class="cursor text-primary"
							:to="{name: 'empresa', params: {id: item.Empresa._EntityId}}"
						>
							<small>{{ item.Empresa.EmpresaNombreComercial || item.Empresa.EmpresaNombre }}</small>
						</router-link>
					</template>

					<template
						slot="importe"
						slot-scope="item"
					>
						{{ item.FacturaTotal }} €
						<invoice-hits-list
							class="float-right"
							:data="item"
						/>
					</template>

					<template
						slot="estado"
						slot-scope="item"
					>
						<invoice-status
							:data="item"
							class="float-right"
						/>
					</template>
					<template
						slot="pdf"
						slot-scope="item"
					>
						<g-upload
							accept=".pdf"
							name="FacturaPDF"
							size="small"
							app="facturas"
							class="mr-2"
							:item="item._EntityId"
							:file-name="'factura_'+item._EntityId+'.pdf'"
							:folder-name="'facturas'"
							:value="item.FacturaPDF"
						/>
					</template>

					<template
						slot="actions"
						slot-scope="item"
					>
						<g-item-actions
							:app="app"
							:item="item"
							:disabled="itemWorking.id === item._EntityId"
							mode="dropdown"
							@edit="$router.push({name: 'facturas_edit', params: {id: $event._EntityId}})"
						>
							<template slot="text">
								<a-button :loading="itemWorking.id === item._EntityId">
									{{ itemWorking.id === item._EntityId ? itemWorking.text : 'Acciones' }}
								</a-button>
							</template>

							<template slot="top">
								<!-- Enviar email -->
								<a-menu-item
									v-if="item.FacturaPDF"
									key="2"
									:disabled="itemWorking.id === item._EntityId"
									@click="mailerScope = item"
								>
									<fa-icon
										:icon="['far','paper-plane']"
										class="mr-2"
									/> Enviar email
								</a-menu-item>

								<!-- Crear PDF -->
								<a-menu-item
									key="0"
									:disabled="itemWorking.id === item._EntityId"
								>
									<a-popconfirm
										v-if="$gestios.items('facturas').auth({
											scopes: [`set.mine`, `set`],
											strict: false,
											item
										})"
										title="¿Se regenerará el PDF de la factura. ¿Estas seguro?"
										@confirm="() => createPDF(item)"
									>
										<fa-icon
											:icon="['fas','file-pdf']"
											class="mr-2"
										/>
										Generar PDF
									</a-popconfirm>
								</a-menu-item>
							</template>
						</g-item-actions>
					</template>
				</g-table-sync>
			</div>
		</div>

		<mailer
			:item="mailerScope"
			:view="view"
			@close="mailerScope = null"
		/>
	</div>
</template>

<script>
import mailer from './mailer';
import facturasMX from '../../helpers/facturas';

export default {
	name: 'FacturasList',
	components: {
		mailer
	},
	mixins: [facturasMX],
	data() {
		return {
			app: 'facturas',
			view: 'facturasList',
			itemWorking: {
				id: null,
				text: ''
			},
			mailerScope: null,
			columns: [
				{
					title: 'ID',
					index: 'FacturaSerie',
					order: true,
					search: true,
					width: '80px'
				},
				{
					title: 'Empresa',
					index: 'EmpresaNombre',
					slot: 'empresa',
					search: true
				},
				{
					title: 'Importe',
					index: 'FacturaTotal',
					slot: 'importe',
					order: true,
					search: true,
					width: '150px'
				},
				{
					title: 'Fecha',
					index: 'FacturaFecha',
					slot: '_date',
					order: true,
					search: false
				},
				{
					title: 'Email',
					index: 'Email',
					slot: '_email'
				},
				{
					title: 'PDF',
					index: 'FacturaPDF',
					slot: 'pdf'
				},
				{
					title: 'Estado',
					align: 'right',
					index: 'FacturaEstado',
					slot: 'estado',
					filters: [
						{
							text: 'Pendiente',
							value: '0'
						},
						{
							text: 'Pagada',
							value: '2'
						},
						{
							text: 'Impagada',
							value: '1'
						}
					]
				},
				{
					title: ' ',
					slot: 'actions',
					align: 'right'
				}
			]
		};
	},
	computed: {
		empresa() {
			return this.$route.query.empresa || 0;
		},
		filters() {
			if (this.empresa > 0) {
				return [{
					field: 'Empresa',
					type: 'number',
					value: this.empresa,
					lig: '='
				}];
			}

			return [];
		}
	},
	methods: {
		async createPDF(item) {
			if (this.itemWorking.id === null) {
				this.itemWorking = {
					id: item._EntityId,
					text: 'Generando PDF'
				};

				await facturasMX.renderPDF(item);

				this.itemWorking = {
					id: null,
					text: ''
				};
			} else {
				this.$message.error('Ya existe otro proceso ejecutándose. Espera hasta que se complete.');
			}
		}
	}
};
</script>

<style lang="scss"></style>
